import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { DirectoryRecord, FileRecord } from "@/shared/domain/files";
import { MoveNodeOperation } from "@/shared/domain/files/operations";

import * as GetDirectoryContents from "./useDirectoryContents";
import * as GetDirectoryItemCount from "./useDirectoryItemCount";

type BulkMoveNodesMutationArgs = {
  datasetId: string;
  operations: MoveNodeOperation[];
};

export function useBulkMoveNodesMutation() {
  const { files: fileService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<
    (FileRecord | DirectoryRecord)[],
    Error,
    BulkMoveNodesMutationArgs
  >({
    mutationFn: ({ datasetId, operations }) => {
      return fileService.bulkMoveNodes(datasetId, operations);
    },
    onSuccess: () => {
      const countPromise = queryClient.invalidateQueries({
        queryKey: GetDirectoryItemCount.getQueryKey(),
        exact: false,
      });

      const contentsPromise = queryClient.invalidateQueries({
        queryKey: GetDirectoryContents.getQueryKey(),
        exact: false,
      });

      return Promise.all([countPromise, contentsPromise]);
    },
  });
}
